/**
 * Централизованная система предзагрузки 3D моделей
 * Экспортирует функции для загрузки критических и дополнительных моделей
 */

import { loadCriticalModelsAsync, loadAdditionalModelsAsync } from './loader.js';
import { CRITICAL_MODELS, ADDITIONAL_MODELS } from './modelPaths.js';

/**
 * Загружает все модели (критические синхронно, дополнительные в фоне)
 * @returns {Promise<boolean>}
 * @throws {Error}
 */
export async function loadAllModelsAsync() {
    const criticalLoaded = await loadCriticalModelsAsync(CRITICAL_MODELS);

    if (!criticalLoaded) {
        throw new Error('Не удалось загрузить критические модели');
    }

    loadAdditionalModelsAsync(ADDITIONAL_MODELS);

    return true;
}

export { loadCriticalModelsAsync, loadAdditionalModelsAsync };
export { CRITICAL_MODELS, ADDITIONAL_MODELS, MODEL_PATHS } from './modelPaths.js';
export { LOAD_TIMEOUTS } from './constants.js';
